// extracted by mini-css-extract-plugin
export default {"blueColor":"#4a90e2","container":"UrxXuWtyonXGxrufjeYon","accepted":"_3y9V-7Wo8V6OBlETgbSf5P","actions":"_2O4tOyNjF_rbWtYd_FqLso","pending":"_1P2_5vxZtziJBJqOdrJWL4"};